import React, { useState } from 'react';
import Loading from '../components/Loading';
import { getChineseZodiacReading, isGeminiReady } from '../services/geminiService';
import { getChineseZodiac } from '../data/astroData';
import { useLanguage } from '../context/LanguageContext';

export default function ChineseZodiac() {
  const [year, setYear] = useState('');
  const [animal, setAnimal] = useState(null);
  const [reading, setReading] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { language, t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const yearNum = parseInt(year, 10);
    if (!yearNum || yearNum < 1900 || yearNum > 2030) {
      setError(t('invalidYear'));
      return;
    }
    if (!isGeminiReady()) {
      setError(t('apiKeyError'));
      return;
    }

    const zodiac = getChineseZodiac(yearNum);
    setAnimal(zodiac);
    setLoading(true);
    setError('');
    setReading('');
    try {
      const result = await getChineseZodiacReading(yearNum, zodiac.animal, language);
      setReading(result);
    } catch (err) {
      setError(err.message || 'Failed to get Chinese zodiac reading.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h2>{t('chineseTitle')}</h2>
          <p>{t('chineseDesc')}</p>
        </div>

        <div className="card" style={{ maxWidth: '400px', margin: '0 auto 2rem', textAlign: 'center' }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ textAlign: 'left' }}>
              <label>{t('birthYear')}</label>
              <input
                type="number"
                value={year}
                onChange={e => setYear(e.target.value)}
                placeholder={t('yearPlaceholder')}
                min="1900"
                max="2030"
                required
              />
            </div>
            <button className="btn btn-gold" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? t('discovering') : t('discoverChinese')}
            </button>
          </form>
        </div>

        {animal && !loading && (
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <span style={{ fontSize: '5rem' }}>{animal.emoji}</span>
            <h3 style={{ fontFamily: 'var(--font-heading)', color: 'var(--accent-gold)', fontSize: '1.8rem' }}>
              {t('yearOfThe', { animal: animal.animal })}
            </h3>
            <p style={{ color: 'var(--text-secondary)' }}>{t('bornIn', { year })}</p>
          </div>
        )}

        {loading && <Loading message={t('loadingChinese')} />}
        {error && <div className="error-message">{error}</div>}

        {reading && (
          <div className="result-container">
            <div className="result-card">
              <h3>{t('chineseResult', { animal: animal.animal, year })}</h3>
              <div className="content">{reading}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
